import React from "react";
import { Box } from "@mui/material";
import { FilterInputProps } from "./FilterInput.types";
import { MelaInput } from "../../../mela/MelaInput";

/**
 * Number range filter input component (Min/Max).
 */
export const NumberRangeFilter: React.FC<FilterInputProps> = ({
  value,
  onChange,
  density = "standard",
}) => {
  const range = (value as { min: number | null; max: number | null }) || {
    min: null,
    max: null,
  };

  const handleMinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value === "" ? null : Number(e.target.value);
    if (val === null && range.max === null) {
      onChange(null);
    } else {
      onChange({ ...range, min: val });
    }
  };

  const handleMaxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value === "" ? null : Number(e.target.value);
    if (val === null && range.min === null) {
      onChange(null);
    } else {
      onChange({ ...range, max: val });
    }
  };

  const size =
    density === "compact" ? "xxs" : density === "standard" ? "xs" : "sm";

  return (
    <Box sx={{ display: "flex", gap: 0.5, alignItems: "center" }}>
      <MelaInput
        type="number"
        size={size}
        placeholder="Min"
        value={range.min ?? ""}
        onChange={handleMinChange}
        fullWidth
      />
      <MelaInput
        type="number"
        size={size}
        placeholder="Max"
        value={range.max ?? ""}
        onChange={handleMaxChange}
        fullWidth
      />
    </Box>
  );
};
